import _ from 'lodash'
import React from 'react'
import { Form } from 'react-bootstrap'
import NumberFormatValidate from '../../../../../components/NumberFormatValidate'

import ResidentialItems from './ResidentialItems'
import { isNumeric } from '../../../../../utils/utilsT'
import { CargoT, CargoKeysT } from '../../../../../types/CargoT'
import { parseFloatTotal } from '../../Job'

export type ICubeSheetLineItemProps = {
  index: number
  item: CargoT
  removeCargoItem(): void
  onChangeItem(item: CargoT): void
}

const CubeSheetLineItem: React.FC<ICubeSheetLineItemProps> = (props) => {

  const getOptions = (category: string) => {
    const find = ResidentialItems.find((x) => x.category == category)
    if (find) {
      return find.items.map((item, index) => {
        return (
          <option value={item.item}>{item.item}</option>
        )
      })
    }
    return null
  }

  const onChangeFields = (key: CargoKeysT, value: any) => {
    let cloneItem = _.cloneDeep(props.item)
    cloneItem = {
      ...cloneItem, ...{
        [key]: value
      }
    }
    props.onChangeItem(cloneItem)
  }


  const total = () => {
    return Number(props?.item?.volume) * Number(props?.item?.units)
  }

  const pounds = () => {
    let t = (Number(props.item.volume) * Number(props.item.units)) * 7
    if (_.isNil(t) || _.isNaN(t)) {
      return 0
    }
    return Number(t)
  }


  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 30px', gap: 4 }}>
      <div>
        <Form.Label>Item</Form.Label>
        <Form.Control
          as='select'
          className='input-material'
          value={props.item.item}
          onChange={(event) => {
            onChangeFields("item", event.target.value)
          }}
        >
          <option></option>
          {getOptions(props.item.category)}
        </Form.Control>
      </div>
      <div>
        <Form.Label>Volume</Form.Label>
        <NumberFormatValidate
          customInput={Form.Control}
          className="input-material"
          type="text"
          defaultValue={`${props.item.volume}`}
          value={`${props.item.volume}`}
          onValueChange={(values) => {
            const { formattedValue, value, floatValue } = values;
            if (floatValue != props.item.units) {
              onChangeFields("volume", floatValue)
            }
            // updateLineItem('units', floatValue, index)
          }}
          mask="_"
          fixedDecimalScale={true}
          decimalScale={2}
        />

      </div>

      <div>
        <Form.Label>Units</Form.Label>
        <NumberFormatValidate
          customInput={Form.Control}
          className="input-material"
          type="text"
          defaultValue={`${props.item.units}`}
          value={`${props.item.units}`}
          onValueChange={(values) => {
            const { formattedValue, value, floatValue } = values;
            if (floatValue != props.item.units) {
              onChangeFields("units", floatValue)
            }
            // updateLineItem('units', floatValue, index)
          }}
          mask="_"
          fixedDecimalScale={true}
          decimalScale={2}
        />

      </div>
      <div>
        <Form.Label>Total</Form.Label>
        <Form.Control
          className='input-material'
          disabled
          value={`${parseFloatTotal(`${ Number(props?.item?.volume) * Number(props?.item?.units)}`)}`} />
      </div>
      <div>
        <Form.Label>Pounds</Form.Label>
        <Form.Control
          disabled
          className='input-material'
          // value={`${pounds}`}
          value={`${parseFloatTotal(`${pounds()}`)}`}
          onChange={(event) => {
            // onChangeFields("volume",event.target.value)
          }}
        />
      </div>

      <div style={{ cursor: "pointer" }} onClick={(): void => { props.removeCargoItem() }}>
        x
      </div>
    </div>
  );
}
export default CubeSheetLineItem
